import { render } from "./CarouselBannerSlide.vue?vue&type=template&id=4451274c&scoped=true"
import script from "./CarouselBannerSlide.vue?vue&type=script&lang=js"
export * from "./CarouselBannerSlide.vue?vue&type=script&lang=js"

import "./CarouselBannerSlide.vue?vue&type=style&index=0&id=4451274c&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4451274c"]])

export default __exports__